import { render, staticRenderFns } from "./TrailerModal.vue?vue&type=template&id=9c405dfc&"
import script from "./TrailerModal.vue?vue&type=script&lang=js&"
export * from "./TrailerModal.vue?vue&type=script&lang=js&"
import style0 from "./TrailerModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/mgrunwald/Projects/Vue.js/playground/movie-app-dev/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VIcon,VSpacer})
